/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const HomeIcon = /*#__PURE__*/ createSvgIcon(
  'HomeIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.5 15.5h2v-4.25c0-.213.072-.39.216-.534a.726.726 0 01.534-.216h3.5c.213 0 .39.072.534.216a.726.726 0 01.216.534v4.25h2V8.25L10 4.875 5.5 8.25v7.25zM4 15.25v-7c0-.234.052-.456.156-.665.104-.21.254-.39.448-.543l4.5-3.375c.278-.195.577-.292.896-.292.32 0 .618.097.896.292l4.5 3.375c.194.152.344.334.448.543.104.21.156.431.156.665v7c0 .481-.171.893-.514 1.236A1.685 1.685 0 0114.25 17h-2.5a.726.726 0 01-.534-.216.726.726 0 01-.216-.534V12H9v4.25c0 .212-.072.39-.216.534A.726.726 0 018.25 17h-2.5c-.481 0-.893-.171-1.236-.514A1.685 1.685 0 014 15.25z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default HomeIcon;
